export const SELECTORS = {
  SECTION: 'js-promo-with-video'
};
